import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getDaysLeftOnTrial, getUserFirstName } from 'src/redux/fe-data/selectors';
import { generateSegmentProperties } from 'src/redux/segment/selectors';
import { trackEvent, TRACKS_THIRD_ARM } from 'src/util/segment-storeless';
import appStyles from '../App/styles.module.css';
import styles from '../NurtureBar/styles.module.css';
import NurtureSummary from './NurtureBarSummary';
import IntroModal from './IntroModal';
import GoalsModal from './GoalsModal';

function VariantOnboarding({
  daysLeft, userFirstName, getSegmentProps
}) {
  const [showIntroModal, setShowIntroModal] = useState(false);
  const [showGoalsModal, setShowGoalsModal] = useState(false);

  const startOnboardingFlow = () => {
    setShowIntroModal(false);
    setShowGoalsModal(true);
  };

  const handleSummaryClick = (ctaType) => {
    trackEvent(TRACKS_THIRD_ARM.nurture_banner, { ctaType });
    setShowGoalsModal(true);
  };

  const isFirstTimeLoadingExperiment = !window.localStorage.getItem('hasSeenOnboardingExperiment');

  useEffect(() => {
    if (isFirstTimeLoadingExperiment) {
      window.localStorage.setItem('hasSeenOnboardingExperiment', 'true');
      setShowIntroModal(true);
    }
  }, []);

  return (
    <div className={appStyles.reactNurtureBar}>
      <div className={styles.nurtureBar}>
        <NurtureSummary
          onSummaryClick={handleSummaryClick}
          daysLeft={daysLeft}
        />
        <IntroModal
          showModal={showIntroModal}
          startOnboardingFlow={startOnboardingFlow}
          name={userFirstName}
          daysLeft={daysLeft}
          getSegmentProps={getSegmentProps}
        />
        <GoalsModal
          showModal={showGoalsModal}
          closeModal={() => setShowGoalsModal(false)}
          getSegmentProps={getSegmentProps}
        />
      </div>
    </div>
  );
}

VariantOnboarding.propTypes = {
  daysLeft: PropTypes.number.isRequired,
  userFirstName: PropTypes.string.isRequired,
  getSegmentProps: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  daysLeft: getDaysLeftOnTrial(state),
  userFirstName: getUserFirstName(state),
  getSegmentProps: generateSegmentProperties(state),
});

export default connect(mapStateToProps)(VariantOnboarding);
